module.exports = __webpack_public_path__ + "static/media/mk-MK.01dd8844.md";